// removed by extract-text-webpack-plugin
module.exports = {"public-status":"_3OLp-wK5sWHaZDNkO31IWU_0","a":"_3aNSfxnQ-WI1AZlTPGwJmA_0","pdf-guide":"FNHl2RWiWmr0FAMm078Or_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4779810c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Website.vue
// module id = Ycel
// module chunks = 1